<template>
    <div>
        <b-row>
            <b-col>
                <el-input size="small"
                          placeholder="Buscar"
                          v-model="params.filter"
                ></el-input>
            </b-col>

            <b-col>
                <b-button variant="primary"
                          @click="fetchHygienicMeasurements(true)"
                          :disabled="!params.company_id"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-search"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Buscar'"
                    />
                </b-button>

                <b-button :disabled="!params.company_id"
                          size="sm"
                          @click="resetParamsFilter"
                          class="mx-1"
                >
                    <i class="fa fa-eraser"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Limpiar'"
                    />
                </b-button>

                <b-button variant="primary"
                          :disabled="!params.company_id"
                          size="sm"
                          @click="openModalForCreation()"
                          class="float-right"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Crear'"
                    />
                </b-button>
            </b-col>
        </b-row>

        <b-table hover
                 striped
                 responsive
                 :fields="fields"
                 show-empty
                 empty-text="No hay GES para mostrar"
                 :items="hygienic_measurements.data"
                 class="mt-3"
        >
            <template v-slot:cell(actions)="data">
                <el-tooltip v-if="validarPermisoComponente('empresa-editar-ges')" popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Editar"
                >
                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="openModalForEdition(data.item)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>
                </el-tooltip>

                <el-tooltip v-if="validarPermisoComponente('empresa-ver-ges')" popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Mediciones higiénicas"
                >
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="openModalResults(data.item)"
                    >
                        <i class="fa fa-list"/>
                    </b-btn>
                </el-tooltip>


                <el-tooltip v-if="validarPermisoComponente('empresa-editar-ges')" popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Eliminar"
                >
                    <b-btn variant="danger"
                           class="mx-1"
                           size="sm"
                           @click="deleteHygienicMeasurement(data.item.id)"
                    >
                        <i class="fa fa-trash"/>
                    </b-btn>
                </el-tooltip>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="hygienic_measurements.data && !!hygienic_measurements.data.length"
                       v-model="params.page"
                       @size-change="fetchHygienicMeasurements(true)"
                       @current-change="fetchHygienicMeasurements()"
                       :current-page.sync="params.page"
                       class="float-right mb-2"
                       :page-size.sync="params.per_page"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="hygienic_measurements.total"
        />

        <modal/>
        <modal_result/>
        <modal_results/>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

import modal from './modal.vue';
import modal_result from './modal_result.vue';
import modal_results from './modal_results.vue';
import { defaultFilterHistRev } from '@/servicios/productos/adjuntos/state';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  watch: {
  },
    name: 'index',
    components: {
        modal,
        modal_result,
        modal_results
    },
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    'label': 'Código',
                    thStyle: 'width: 120px; min-width: 120px',
                },
                {
                    key: 'name',
                    label: 'GES',
                    thStyle: 'width: 250px; min-width: 250px',
                },
                {
                    key: 'description',
                    label: 'Descripción'
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 120px',
                    tdClass: 'text-nowrap text-right'
                },
            ],
            company_id: this.$route.params.id,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('hygienic_measurements', [
            'hygienic_measurements',
            'params',
            'companies'
        ]),
    },
    async created() {
        this.resetParams();
        this.params.company_id = this.company_id;
        await this._fetchData();
        this.load(false);
    },
    methods: {
        ...mapActions('hygienic_measurements', [
            'fetchCompanies',
            'fetchHygienicMeasurements',
            'getHygienicMeasurement',
            'deleteHygienicMeasurement',
            'fetchPositions',
            'fetchResults'
        ]),
        ...mapMutations('hygienic_measurements', [
            'setModalShow',
            'resetParams',
            'setEditing',
            'resetHygienicMeasurement',
            'setStepToModal',
            'setHygienicMeasurement',
            'setModalImage',
            'setShowToModalResults'
        ]),
        ...mapMutations('dashboard', ['load']),
        async _fetchData() {
            await this.fetchHygienicMeasurements(true);
            await this.fetchPositions();
        },
        async openModalForCreation() {
            this.resetHygienicMeasurement();
            this.setEditing(false);
            this.setModalShow(true);
        },
        async openModalForEdition(hygienic_measurement) {
            await this.getHygienicMeasurement(hygienic_measurement.id);
            await this.setEditing(true);
            await this.setModalShow(true);
        },
        async openModalResults(hygienic_measurement) {
            this.setHygienicMeasurement(hygienic_measurement);

            await this.fetchResults(true)

            this.setShowToModalResults(true)
        },
        async resetParamsFilter() {
            this.resetParams();
            this.params.company_id = this.company_id;
            await this._fetchData();
        }
    },
};
</script>

<style scoped>
</style>
